import { AxiosPromise, AxiosResponse } from 'axios';
import { apiService } from '@app/services';

class FeatureService {
    readonly apiBase: string = '/api/feature';

    checkFeature(featureName: string): AxiosPromise {
        return apiService
            .get(
                `${this.apiBase}/check`,
                {
                    params: {
                        featureName: featureName
                    },
                    local: true
                })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }
}

export const featureService = new FeatureService();
